<template>
  <div
    v-if="!loading"
    class="single-column">
    <section class="single-column__section">
      <h2 class="single-column__heading">メールアドレス変更</h2>
      <div class="form-complete-area">
        <div v-if="result">
          <div
            class="form-complete-area__title"
            style="padding-bottom: 32px">
            メールアドレスを変更しました。
          </div>
          次回ログイン時より新しいメールアドレスでログインして下さい。
        </div>
        <div v-else>
          <div
            class="form-complete-area__title"
            style="padding-bottom: 32px">
            このURLは無効です
          </div>
          再度メールアドレス変更手順を実施して下さい。
        </div>
      </div>
      <div class="c-btn-wrap">
        <router-link
          :to="{ name: 'index' }"
          class="c-btn c-btn--back">
          戻る
          <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      result: false,
      loading: true,
    }
  },
  mounted() {
    this.verifyToken(this.$route.params.token)
  },
  methods: {
    async verifyToken(token) {
      const { data } = await window.axios.post('/api/client/verify/email', { token })
      this.result = data.result
      this.loading = false
    },
  },
}
</script>

<style scoped>

</style>
